module.exports = __webpack_public_path__ + "assets/media/game-lose.968922e4.mp3";